import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import menuIcon from "../../assets/images/header-menu-Icon.png";
import searchicon from "../../assets/images/searchicon.svg";
import dividerLine from "../../assets/images/Line.svg";
import etihadlogo from "../../assets/images/etihadlogo.svg";
import loginIcon from "../../assets/images/login-icon.svg";
import envConfigs from "../../configs/envConfigs";
import { getOktaSession } from "../../services/authService";
import {
	getMenuResponse,
	getMenuResponseFromAPI,
} from "../../services/onLoadServices";
import "./header.scss";
import { USER_PRIVLILEGES } from "../../constants";
import { useTranslation } from "react-i18next";
import MobileMenuModal from "./MobileMenuModal";
import { pushEventDashboardHeaders } from "../../utils/analytics";
import { getFromLocalStorage } from "../../utils/StorageUtils";
import getCurrentUser from "../../utils/getCurrentUser";
import SwitchAgentPopover from "../GsaUserAgentSelect/GsaUserAgentSelectHeader";
import LoadingIndicator from "../LoadingIndicator";
import { useLocation } from "react-router-dom";
import ellipse from "../../assets/images/Ellipse.svg";
import SubHeader from "../../common/Resusable/SubHeader/SubHeader.js";
import Patterns from "../../assets/images/Patterns.svg";
import PatternsMob from "../../assets/images/PatternsMobile.svg";
import lockIcon from "../../assets/images/locked-icon.png";
import companionIcon from "../../assets/images/companion-icon.png";
import dashboardIcon from "../../assets/images/financial-icon.png";
import accountIcon from "../../assets/images/account-icon.png";
import globeIcon from "../../assets/images/globeWhite.svg";
import downIcon from "../../assets/images/chevronDownWhite.svg";
import switchIcon from "../../assets/images/settings-window.png";
import { LanguageChangePopup } from "./LanguageChangePopup.js";
import { CommonDropDown } from "../../common/Resusable/CommonDropDown.js";
import tailFin from "../../assets/images/tailFInHeaderIcon.svg";
import { LanguageDropdown } from "./LanguageDropdown.js";


const languageOptions = [
	{ label: "English", value: "en" },
	{ label: "العربية", value: "ar" },
	{ label: "Deutsch", value: "de" },
	{ label: "Español", value: "es" },
	{ label: "简体中文", value: "zh" },
	{ label: "日本語", value: "ja" }
];

const PortalHeader = ({
	userDetails,
	ssoRefreshUrl,
	ssoType,
	gsaAgentData,
	setToGsaAgent,
}) => {
	const { t, i18n } = useTranslation(["labels"]);
	const isRTL = i18n.language === 'ar' || i18n.dir() === 'rtl';

	// const [selectedLanguage, setSelectedLanguage] = React.useState("en");

	// const onLanguageChange = (e) => {
	// 	setSelectedLanguage(e.value);
	// };

	const [selectedLanguage, setSelectedLanguage] = React.useState("en");

	const onLanguageChange = (value) => {
		setSelectedLanguage(value);
	};

	useEffect(() => { setSelectedLanguage(i18n.language) }, [i18n.language])


	const [menuResponse, setMenuResponse] = useState(null);

	const [oktaUrl, setOktaUrl] = useState(null);

	const location = useLocation();

	const [showAgentChangeHeader, setShowAgentChangeHeader] = useState(false);

	const [subHeaderText, setSubHeaderText] = useState("");

	const [displayLoginOverlay, setDisplayLoginOverlay] = useState(false);

	const loginOverlayRef = useRef(null);
	const iconClickedRef = useRef(false);

	const [isEyAdmin, setIsEyAdmin] = useState(false);
	const [isEnterprise, setIsEnterprise] = useState(false);
	const [isGSA, setIsGSA] = useState(false);
	const [viewCSN, setViewCSN] = useState(false);

	const [showMobileMenu, setShowMobileMenu] = useState(false);
	const [customWidth, setcustomWidth] = useState(window.innerWidth);
	const {
		bookingPortalAppUrl,
		checkSessionInterval,
		cosumerOktaSsoUrl,
		enterpriseOktaSsoUrl,
		parentUrl
	} = envConfigs;
	const [hideMenu, setHideMenu] = useState(false);
	const { agentDetails } = gsaAgentData;
	const [showGsaAgentPopup, setShowGsaAgentPopup] = useState(false);
	const [showLangPopup, setShowLangPopup] = useState(false);
	const [selectedLang, setSelectedLang] = useState("en");
	const [isLoading, setIsLoading] = useState(false);
	const [scrolled, setScrolled] = useState(false);
	const [isDeactivatedUser, setIsDeactivatedUser] = useState(false);
	const [hideGsaHeader, setHideGsaHeader] = useState(false);


	// useEffect(() => {
	// 	setIsDeactivatedUser(localStorage.getItem('isDeactivatedUser') === 'true');
	// }, [location]);

	// useEffect(() => {
	// 	const localDeactivated = localStorage.getItem('isDeactivatedUser') === 'Y';
	// 	const userStatusDeactivated = userDetails && userDetails.status === false;
	// 	setIsDeactivatedUser(localDeactivated || userStatusDeactivated);

	// }, [location, userDetails]);

	useEffect(() => {
		const checkDeactivation = () => {

			const localDeactivated = sessionStorage.getItem('isDeactivatedUser') === 'Y';
			const currentUserDetails = getCurrentUser();

			const isStatusDeactivated = (status) => status === false;

			const userStatusDeactivated =
				(userDetails && isStatusDeactivated(userDetails.status)) ||
				(currentUserDetails && isStatusDeactivated(currentUserDetails.status));

			setIsDeactivatedUser(localDeactivated || userStatusDeactivated);
		};

		checkDeactivation();

		window.addEventListener('deactivationChange', checkDeactivation);
		window.addEventListener('userDetailsChange', checkDeactivation);

		return () => {
			window.removeEventListener('deactivationChange', checkDeactivation);
			window.removeEventListener('userDetailsChange', checkDeactivation);
		};
	}, [userDetails]);

	const getSubHeaderText = (pathname) => {
		if (!pathname || pathname === "/") return "Dashboard";
		const firstSegment = pathname?.split("/")?.at(1)?.toLowerCase();
		switch (firstSegment) {
			case "dashboard":
				return "Dashboard";
			case "booking":
			case "manage-booking":
			case "shipment-tracking":
			case "flight-enquiry":
			case "manage-template":
			case "permanent-booking":
				return t("COMMON.BKG");
			case "reports":
				return t("COMMON.REPORTS");
			case "user-management":
				return t("DASHBOARD.USER_MANAGEMENT");
			// case "schedule-visualization":
			// 	return "Schedule-Visualization";
			case "capture-awb":
				return t("COMMON.AWB/HAWB");
			case "csn-dashboard":
				return t("COMMON.DASHBOARD");
			case "user-select":
				return t("COMMON.GSA_USER_SELECT");
			default:
				return null;
		}
	};

	useEffect(() => {
		setShowAgentChangeHeader(
			!(location.pathname && ["/csn-dashboard"].includes(location.pathname))
		);
		if (location?.pathname) {
			setSubHeaderText(getSubHeaderText(location.pathname));
		}
	}, [location, i18n?.language]);

	useEffect(() => {
		if (location?.pathname) {
			setSubHeaderText(getSubHeaderText(location.pathname));
		}
	}, [location?.pathname, i18n?.language]);

	useEffect(() => {
		(async () => {
			getNavigationMenu();
			i18n.on("languageChanged", function (lng) {
				getNavigationMenu();
			});
		})();
	}, []);

	useEffect(() => {
		let ticking = false;
		const handleScroll = () => {
			if (!ticking) {
				window.requestAnimationFrame(() => {
					setScrolled(window.scrollY > 46);
					const isMobView = customWidth <= 992;
					if (isMobView) {
						setHideGsaHeader(window.scrollY > 23);
					} else {
						setHideGsaHeader(window.scrollY > 65);
					}

					ticking = false;
				});
				ticking = true;
			}
		};

		window.addEventListener("scroll", handleScroll);
		return () => {
			window.removeEventListener("scroll", handleScroll);
		};
	}, [customWidth]);

	const updateDimensions = () => {
		setcustomWidth(window.innerWidth);
	};

	useEffect(() => {
		window.addEventListener("resize", updateDimensions);
		return () => window.removeEventListener("resize", updateDimensions);
	}, []);

	useEffect(() => {
		setShowMobileMenu(false);
	}, [customWidth]);

	useEffect(() => {
		if (userDetails && userDetails.roles && userDetails.roles.length) {
			if (userDetails.roles.includes(USER_PRIVLILEGES.EY_ADMIN_PRIVILEGE)) {
				setIsEyAdmin(true);
			} else {
				setIsEyAdmin(false);
			}
		}
	}, [userDetails]);

	useEffect(() => {
		if (userDetails && userDetails.roles && userDetails.roles.length) {
			if (
				userDetails.roles.includes(USER_PRIVLILEGES.CSN_DASHBOARD_PRIVILEGE)
			) {
				setViewCSN(true);
			} else {
				setViewCSN(false);
			}
		}
	}, [userDetails]);

	useEffect(() => {
		if (userDetails?.type === "enterprise" || ssoType === "E") {
			setIsEnterprise(true);
		} else {
			setIsEnterprise(false);
		}
	}, [userDetails]);

	useEffect(() => {
		if (userDetails && userDetails.roles && userDetails.roles.length) {
			if (userDetails.roles.includes(USER_PRIVLILEGES.GSA_USER_PRIVILEGE)) {
				setIsGSA(true);
			} else {
				setIsGSA(false);
			}
		}
	}, [userDetails]);

	useEffect(() => {
		// Clear loader after any internal route change
		if (isLoading) setIsLoading(false);
	}, [location.pathname]);

	useEffect(() => {
		(async () => {
			if (ssoRefreshUrl && ssoRefreshUrl !== "") {
				if (checkSessionInterval && checkSessionInterval !== 0) {
					let interval = checkSessionInterval * 60 * 1000;
					setInterval(function () {
						keepOktaSessionAlive(ssoRefreshUrl);
					}, interval);
				}
			}
		})();
	}, [ssoRefreshUrl]);

	useEffect(() => {
		if (ssoType) {
			if (ssoType === "E") {
				setOktaUrl(enterpriseOktaSsoUrl);
			} else if (ssoType === "C") {
				setOktaUrl(cosumerOktaSsoUrl);
			}
		}
	}, [ssoType]);

	const getNavigationMenu = async () => {
		let menuResponse = await getMenuResponseFromAPI(i18n.language)
			.then((response) => {
				if (response && response.navigationmenu) {
					setMenuResponse(response);
					return response;
				} else {
					return null;
				}
			})
			.catch((error) => {
				console.log(error);
				return null;
			});

		if (!menuResponse) {
			menuResponse = await getMenuResponse(i18n.language)
				.then((response) => {
					if (response && response.navigationmenu) {
						setMenuResponse(response);
						return response;
					} else {
						return null;
					}
				})
				.catch((error) => {
					console.log(error);
					return null;
				});
		}
	};

	const keepOktaSessionAlive = async (url) => {
		if (url && url !== "") {
			console.log("Calling okta session url");
			try {
				const status = await getOktaSession(url);
			} catch (err) {
				console.log(err);
			}
		}
	};

	/**
	 * Below useEffect is to handle click outside loginOverlay
	 */
	useEffect(() => {
		function handleClickOutside(event) {
			if (iconClickedRef.current) {
				iconClickedRef.current = false;
				return;
			}
			if (
				loginOverlayRef.current &&
				!loginOverlayRef.current.contains(event.target)
			) {
				setDisplayLoginOverlay(false);
			}

			iconClickedRef.current = false;
		}
		document.addEventListener("mousedown", handleClickOutside);
		return () => {
			document.removeEventListener("mousedown", handleClickOutside);
		};
	}, []);

	const getAvatarLetter = (name) => {
		if (name && name.trim !== "") {
			return name.charAt(0);
		}
	};

	const [hoveredMenu, setHoveredMenu] = useState(null);

	const handleMouseEnter = (title) => {
		setHoveredMenu(title);
	};


	const handleFocusOustide = (e) => {
		if (
			e.relatedTarget &&
			e.relatedTarget instanceof Node &&
			!e.relatedTarget.className?.includes("submenu-container")
		) {
			setHoveredMenu(null);
		}
	};

	useEffect(() => {
		let data = JSON.parse(getFromLocalStorage("subject"));
		if (data && data.roles.includes("CSN_USER") && data.roles.length === 1) {
			setHideMenu(true);
		}
	}, []);

	const handleLangChangeClick = () => {
		console.log("Language changed to:", selectedLanguage);
		i18n.changeLanguage(selectedLanguage);
		setShowLangPopup(false);
	};

	const handleLoginIconClick = (e) => {
		setDisplayLoginOverlay((prev) => !prev);
	};
	// const getSubmenuEServices = ({ categories, navigationsubmenu }) => {
	// 	return (
	// 		<div className="header-navigation-l2-component-container  responsive-cargo-portal-container">
	// 			{categories && categories.length ? (
	// 				categories.map((category) => (
	// 					<div className="header-navigation-l2-component-item-con-wrapper">
	// 						<div className="category-wrapper">
	// 							<h2
	// 								className="subcategory-title-header"
	// 								id="category-title-header~eservices"
	// 							>
	// 								{category.categorytitle}
	// 							</h2>
	// 							<ul
	// 								role="menu"
	// 								aria-label={category.categorytitle}
	// 								className="category-list-item"
	// 							>
	// 								{navigationsubmenu && navigationsubmenu.length ? (
	// 									navigationsubmenu.map((submenu) => {
	// 										return submenu.categorytype === category.categorykey ? (
	// 											<li
	// 												role="none"
	// 												className="header-navigation-l2-component-item hover-out-gold"
	// 											>
	// 												{(submenu.externalPortalLink &&
	// 													submenu.externalPortalLink !== "") ||
	// 													(submenu.redirecturl &&
	// 														submenu.redirecturl.startsWith(
	// 															bookingPortalAppUrl
	// 														)) ? (
	// 													<a
	// 														href={
	// 															submenu.externalPortalLink &&
	// 																submenu.externalPortalLink !== ""
	// 																? submenu.externalPortalLink.replace(
	// 																	bookingPortalAppUrl,
	// 																	""
	// 																)
	// 																: submenu.redirecturl.replace(
	// 																	bookingPortalAppUrl,
	// 																	""
	// 																)
	// 														}
	// 														target={submenu.newwindow}
	// 														className="header-nav-l2-img-container"
	// 														role="menuitem"
	// 														aria-describedby="category-title-header~eservices"
	// 													>
	// 														{submenu.title}
	// 													</a>
	// 												) : (
	// 													<a
	// 														href={
	// 															oktaUrl
	// 																? `${oktaUrl}?RelayState=${encodeURIComponent(
	// 																	submenu.redirecturl
	// 																)}`
	// 																: submenu.redirecturl
	// 														}
	// 														target={submenu.newwindow}
	// 														className="header-nav-l2-img-container"
	// 														role="menuitem"
	// 														aria-describedby="category-title-header~eservices"
	// 													>
	// 														{submenu.title}
	// 													</a>
	// 												)}
	// 											</li>
	// 										) : (
	// 											<></>
	// 										);
	// 									})
	// 								) : (
	// 									<></>
	// 								)}
	// 							</ul>
	// 						</div>
	// 					</div>
	// 				))
	// 			) : (
	// 				<></>
	// 			)}
	// 		</div>
	// 	);
	// };
	const getSubmenuEServices = ({ categories, navigationsubmenu }) => {
		return (
			<div className="header-navigation-l2-component-container  responsive-cargo-portal-container">
				{categories && categories.length ? (
					categories.map((category) => (
						<div className="header-navigation-l2-component-item-con-wrapper" key={category.categorykey}>
							<div className="category-wrapper">
								<h2
									className="subcategory-title-header"
									id="category-title-header~eservices"
								>
									{category.categorytitle}
								</h2>
								<ul
									role="menu"
									aria-label={category.categorytitle}
									className="category-list-item"
								>
									{navigationsubmenu && navigationsubmenu.length ? (
										navigationsubmenu.map((submenu) => {
											if (submenu.categorytype !== category.categorykey) return <></>;

											const isInternal =
												(submenu.externalPortalLink && submenu.externalPortalLink !== "") ||
												(submenu.redirecturl && submenu.redirecturl.startsWith(bookingPortalAppUrl));

											const internalPath = isInternal
												? (submenu.externalPortalLink && submenu.externalPortalLink !== ""
													? submenu.externalPortalLink.replace(bookingPortalAppUrl, "")
													: submenu.redirecturl.replace(bookingPortalAppUrl, ""))
												: null;

											return (
												<li
													role="none"
													className="header-navigation-l2-component-item hover-out-gold"
													key={`${category.categorykey}-${submenu.title}`}
												>
													{isInternal ? (
														<Link
															to={internalPath}
															className="header-nav-l2-img-container"
															role="menuitem"
															aria-describedby="category-title-header~eservices"
															onClick={() => {
																pushEventDashboardHeaders(submenu.title);
																setHoveredMenu(null);
																// internal navigation via SPA (no full reload)
															}}
														>
															{submenu.title}
														</Link>
													) : (
														<a
															href={oktaUrl && submenu.redirecturl.includes(parentUrl)
																? `${oktaUrl}?RelayState=${encodeURIComponent(submenu.redirecturl)}`
																: submenu.redirecturl}
															target={submenu.newwindow}
															className="header-nav-l2-img-container"
															role="menuitem"
															aria-describedby="category-title-header~eservices"
															onClick={(e) => {
																e.preventDefault();
																pushEventDashboardHeaders(submenu.title);
																setHoveredMenu(null);
																if (typeof setIsLoading === 'function') setIsLoading(true);
																const dest = oktaUrl && submenu.redirecturl.includes(parentUrl)
																	? `${oktaUrl}?RelayState=${encodeURIComponent(submenu.redirecturl)}`
																	: submenu.redirecturl;
																// let existing LoadingIndicator render before leaving
																setTimeout(() => {
																	if (submenu.newwindow === '_blank') {
																		window.open(dest, '_blank', 'noopener,noreferrer');
																		if (typeof setIsLoading === 'function') setIsLoading(false);
																	} else {
																		window.location.href = dest;
																	}
																}, 40);
															}}
														>
															{submenu.title}
														</a>
													)}
												</li>
											);
										})
									) : (
										<></>
									)}
								</ul>
							</div>
						</div>
					))
				) : (
					<></>
				)}
			</div>
		);
	};

	const closeProfileMenu = (e) => {
		if (e) e.stopPropagation();
		setDisplayLoginOverlay(false);
	};

	// if (!menuResponse) return <></>;
	return (
		<>
			<div className="portal-header">
				<header
					className={`${scrolled || (!subHeaderText || subHeaderText === 'Dashboard') ? "header-scrolled" : ""}`}
				>
					<div className="header-comp">
						<div className={`header-primary`}>
							<div className="responsive-cargo-portal-container header-navbar-container">
								<div className="header-navbar-left navbar-header">
									<span className="header-navbar-brand navbar-brand">
										<a
											href={
												process.env.REACT_APP_ENV === "stage" ||
													process.env.REACT_APP_ENV === "dev"
													? "https://test.etihadcargo.com"
													: "https://etihadcargo.com"
											}
											target="_self"
											className="header-logo"
										></a>
										<div className="header-text-logo">
											<a
												href={
													process.env.REACT_APP_ENV === "stage" ||
														process.env.REACT_APP_ENV === "dev"
														? "https://test.etihadcargo.com"
														: "https://etihadcargo.com"
												}
												target="_self"
											>
												<img
													src={etihadlogo}
													alt="Etihad Choose Well"
													className="header-text-logo"
												/>
											</a>
										</div>
									</span>
								</div>

								<div className={`header-navbar-right${isDeactivatedUser ? " deactivated-user" : ""}`}>
									<div
										className="header-navbar-right-flex menu-options"
										onMouseLeave={handleFocusOustide}
									>
										<nav className="header-navbar-main-container" aria-label="Primary">
											<ul role="menubar" className="header-rightele" style={{ display: "flex", alignItems: "center" }}>
												{hideMenu ? (
													<></>
												) : menuResponse?.navigationmenu &&
													menuResponse?.navigationmenu.navigation &&
													menuResponse?.navigationmenu.navigation.length ? (
													menuResponse?.navigationmenu.navigation.map((item) => (
														<React.Fragment key={item.title}>
															<li
																aria-haspopup="true"
																aria-expanded="false"
																role="menuitem"
																className="navigation-web-main-head hover-out-gold"
																onMouseLeave={handleFocusOustide}
															>
																{item.redirecturl &&
																	item.redirecturl.startsWith(bookingPortalAppUrl) ? (
																	<Link
																		to={item.redirecturl.replace(bookingPortalAppUrl, "")}
																		aria-expanded="true"
																		aria-haspopup="true"
																		className="navigation-web-main-head-ele"
																		onMouseEnter={() => {
																			if (!isDeactivatedUser) handleMouseEnter(item.title);
																		}}
																		onClick={(e) => {
																			if (isDeactivatedUser) {
																				e.preventDefault();
																				return;
																			}
																			pushEventDashboardHeaders(item.title);
																			setHoveredMenu(null);
																		}}
																	>
																		{item.title}
																	</Link>
																) : (
																	<a
																		href="javascript: void(0);"
																		target={item.newwindow}
																		aria-expanded="true"
																		aria-haspopup="true"
																		className="navigation-web-main-head-ele"
																		onMouseEnter={() => {
																			if (!isDeactivatedUser) handleMouseEnter(item.title);
																		}}
																		onClick={(e) => {
																			if (isDeactivatedUser) {
																				e.preventDefault();
																				return;
																			}
																			pushEventDashboardHeaders(item.title);
																			window.location.href = oktaUrl
																				? `${oktaUrl}?RelayState=${encodeURIComponent(item.redirecturl)}`
																				: item.redirecturl;
																		}}
																	>
																		{item.title}
																	</a>
																)}
															</li>
															<div
																className={`submenu-container ${item.title === hoveredMenu &&
																	item.categories &&
																	item.categories.length
																	? "show"
																	: ""
																	}`}
																onMouseLeave={() => setHoveredMenu(null)}
															>
																{getSubmenuEServices(item)}
															</div>
														</React.Fragment>
													))
												) : (
													<></>
												)}
											</ul>
										</nav>
									</div>
									<ul
										className="header-navitem-right-icons pr-0"
										onMouseEnter={handleFocusOustide}
									>
										<div
											className="lang-search-container"
											onClick={() => {
												if (!isDeactivatedUser) setShowLangPopup(!showLangPopup);
											}}
										>
											<li role="presentation" className="language-selector-box">
												<img src={globeIcon} />
												<span className="language-label">
													{selectedLanguage?.toLocaleUpperCase()}
													<img src={downIcon} className="down-icon" />
												</span>
											</li>
											<li role="presentation" className="divider-line">
												<img src={dividerLine} alt="Divider" className="divider-line-image" />
											</li>
											{!hideMenu && (
												<li role="presentation" className="search-icon-box">
													<a
														href={`${envConfigs.parentUrl}/${i18n.language}/search`}
													>
														<img
															src={searchicon}
															alt="Search Icon"
															className="search-icon"
														/>
													</a>
												</li>
											)}
										</div>
										<li
											role="presentation"
											className={`header-navitem-right-2 ${displayLoginOverlay ? "loggedIn-widget-open" : ""}`}
										>
											{userDetails ? (
												<a
													className="login-icon-button"
													onMouseDown={() => {
														iconClickedRef.current = true;
													}}
													onClick={handleLoginIconClick}
												>
													<span className="firstname-initial" tabIndex="-1">
														{getAvatarLetter(userDetails.firstName)}
														{getAvatarLetter(userDetails.lastName)}
													</span>
													<img src={tailFin} className="tail-fin-icon" />
													<div
														className={`user-profile-menu ${displayLoginOverlay ? "show" : ""}`}
														ref={loginOverlayRef}
													>
														{menuResponse?.loggedIn && (
															<div className="user-profile-menu__custom">
																{/* Header Section (unchanged) */}
																<div className="user-profile-menu-header">
																	<div className="d-flex align-items-center justify-content-between header-content">
																		<div className=" d-flex flex-column">
																			{menuResponse?.loggedIn.welcomeBackText && (
																				<label className="welcome-text mb-0">
																					{menuResponse?.loggedIn.welcomeBackText}
																				</label>
																			)}
																			<div className="user-name">
																				{`${userDetails.firstName ? userDetails.firstName : ""} ${userDetails.lastName ? userDetails.lastName : ""}`}
																			</div>
																		</div>
																	</div>
																</div>

																{/* Content Section */}
																<div className="user-profile-menu__content">
																	<ul className="user-profile-menu__list">
																		{!hideMenu && (
																			<li className="user-profile-menu__item">
																				{(() => {
																					const isExtDashboardRedirection = isEnterprise || isGSA;
																					const rawDashUrl = isExtDashboardRedirection
																						? (process.env.REACT_APP_ENV === "stage" || process.env.REACT_APP_ENV === "dev"
																							? `https://test.etihadcargo.com/${i18n.language}/secured/dashboard`
																							: `https://etihadcargo.com/${i18n.language}/secured/dashboard`)
																						: "/dashboard";
																					const toPath = rawDashUrl.replace(/^https?:\/\/(test\.)?etihadcargo\.com/, "");
																					return (!isExtDashboardRedirection?
																						<Link
																							to={toPath}
																							className="user-profile-menu__link"
																							onClick={(e) => {
																								closeProfileMenu(e);
																							}}
																						>
																							<img
																								src={dashboardIcon}
																								alt="Dashboard"
																								className="user-profile-menu__icon"
																							/>
																							{t("HEADER.VIEW_DASH")}
																						</Link>
																					: <a href={rawDashUrl} className="user-profile-menu__link" target="_self">
																							<img
																								src={dashboardIcon}
																								alt="Dashboard"
																								className="user-profile-menu__icon"
																							/>
																							{t("HEADER.VIEW_DASH")}
																						</a>);
																				})()}
																			</li>
																		)}

																		{menuResponse?.loggedIn.profileBtnText && !hideMenu && (
																			<li className="user-profile-menu__item">
																				<Link
																					to="/user-management"
																					className="user-profile-menu__link"
																					onClick={(e) => {
																						closeProfileMenu(e);
																					}}
																				>
																					<img
																						src={
																							menuResponse?.loggedIn.profileBtnText === "User Management"
																								? companionIcon
																								: accountIcon
																						}
																						alt={menuResponse?.loggedIn.profileBtnText}
																						className="user-profile-menu__icon"
																					/>
																					{t("HEADER.USER_MANAGEMENT")}
																				</Link>
																			</li>
																		)}

																		{!isEnterprise &&
																			menuResponse?.loggedIn.changePassTextLink &&
																			!hideMenu && (
																				<li className="user-profile-menu__item">
																					<a
																						href={menuResponse?.loggedIn.changePassTextLink}
																						target="_blank"
																						rel="noreferrer"
																						className="user-profile-menu__link"
																						onClick={(e) => {
																							closeProfileMenu(e);
																						}}
																					>
																						<img
																							src={lockIcon}
																							alt="password"
																							className="user-profile-menu__icon"
																						/>
																						{t("HEADER.CHANGE_PSWD")}
																					</a>
																				</li>
																			)}
																	</ul>
																</div>

																{/* Footer Section */}
																<div className="user-profile-menu-footer">
																	<div className="d-flex justify-content-center">
																		<button
																			className=" secondary-button user-profile-menu-logout-btn"
																			onClick={(e) => {
																				closeProfileMenu(e);
																				window.location.href = "/logout";
																			}}
																		>
																			{t("HEADER.LOG_OUT")}
																		</button>
																	</div>
																</div>
															</div >
														)}
													</div >
												</a >
											) : (
												<Link
													className="d-flex"
													to="/login"
													onClick={(e) => {
														closeProfileMenu(e);
													}}
												>
													<div className="icon-wrapper">
														{menuResponse?.loggedIn ? (
															<img src={loginIcon} alt="" className="" />
														) : (
															<></>
														)}
													</div>
													<div className="login-section login-text-section my-auto">
														<span className="login-status-text ">Log in</span>
													</div>
												</Link>
											)}
										</li >
										<li role="presentation" className="header-navitem-right-3">
											<a
												role="button"
												onClick={(e) => {
													if (!isDeactivatedUser) setShowMobileMenu(true);
												}}
											>
												<img src={menuIcon} alt="Navigation Menu" />
											</a>
										</li>
									</ul >
								</div >
							</div >
						</div >
					</div >
					<MobileMenuModal
						setShowMobileMenu={setShowMobileMenu}
						menuResponse={menuResponse}
						oktaUrl={oktaUrl}
						show={showMobileMenu}
					/>
					{isLoading && <LoadingIndicator />}
				</header >
				{!subHeaderText || subHeaderText === "Dashboard" ? <div
					className={`gsaUserAgentContainer non-sub ${subHeaderText === "Dashboard" ? 'dashboard' : ''}`}
				>
					{agentDetails?.agentCode &&
						showAgentChangeHeader &&
						subHeaderText !== "GSA User Select" && (
							<SwitchAgentPopover
								agentName={agentDetails?.companyName}
								agentNumber={agentDetails?.agentCode}
								setShowGsaAgentPopup={setShowGsaAgentPopup}
								showGsaAgentPopup={showGsaAgentPopup}
								setIsLoading={setIsLoading}
								t={t}
								gsaAgentData={gsaAgentData}
								setToGsaAgent={setToGsaAgent}
								isNoSubHeaderCase={!subHeaderText}
							/>
						)}
				</div> : <></>}

				{
					subHeaderText && subHeaderText !== "Dashboard" && (
						<div className="booking-heading-wrapper">
							<div className={`responsive-cargo-portal-container booking-heading ${isRTL ? 'rtl' : ''}`}>
								<SubHeader text={subHeaderText} />
								<div
									className={`gsaUserAgentContainer`}
								>
									{agentDetails?.agentCode &&
										showAgentChangeHeader &&
										subHeaderText !== "GSA User Select" && (
											<SwitchAgentPopover
												agentName={agentDetails?.companyName}
												agentNumber={agentDetails?.agentCode}
												setShowGsaAgentPopup={setShowGsaAgentPopup}
												showGsaAgentPopup={showGsaAgentPopup}
												setIsLoading={setIsLoading}
												t={t}
												gsaAgentData={gsaAgentData}
												setToGsaAgent={setToGsaAgent}
												isNoSubHeaderCase={!subHeaderText}
											/>
										)}
								</div>
							</div>
							<img src={Patterns} className="desktop-header-pattern" />
						</div>
					)
				}
				<LanguageChangePopup
					isVisible={showLangPopup}
					footerPriBtnLabel={t("COMMON.APPLY")}
					footerPriBtnClick={handleLangChangeClick}
					onClose={() => setShowLangPopup(false)}
					headerComponent={{
						mainHeader: `${t("COMMON.CHOOSE")} ${t("COMMON.PREF")}`,
					}}
					body={

						<div className="lang-change-popup w-100">
							<LanguageDropdown
								label={`${t("COMMON.SELECT")} ${t("COMMON.LANG")}`}
								options={languageOptions}
								value={selectedLanguage}
								onChange={onLanguageChange}
							/>
							{/* <CommonDropDown
								label={`${t("COMMON.SELECT")} ${t("COMMON.LANG")}`}
								options={languageOptions}
								value={selectedLanguage}
								onChange={onLanguageChange}
							/> */}
						</div>
					}
				/>

				<img src={PatternsMob} className={`mob-header-pattern ${!subHeaderText || subHeaderText === 'Dashboard' ? "d-none" : ""}`} />
			</div >
		</>
	);
};

export default PortalHeader;
